import api from '@/helpers/api'
import Page from "../pages/model";
import Questions from "../questions/model";
import {isArray} from 'lodash'
import { map } from 'lodash/collection'

import { saveAnswer, resetCache, createTest } from '../../cache'

export default {
    state: {

    },

    mutations: {

    },

    getters: {
        index(state, getters) {
            return getters.query().with(['ticket', 'questions.options']).where('finishedAt', value => value !== null).get()
        },
        testById (state, getters) {
            return (testId) => {
                return getters.query().with(['ticket', 'questions.options']).find(testId)
            }
        },
        activeTest(state, getters) {
            return getters.query().where('finishedAt', null).with(['ticket', 'questions.options']).first()
        }
    },

    actions: {
        finish(store, answer) {
            Page.dispatch('addLoader', 'tests.finishTest')

            let params = {
                Id: answer.testId,
                TicketId: answer.ticketId,
            }
            return api.post(`/api/v1/activities/Finish`, {}, {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                resetCache()
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'tests.finishTest')
            })
        },
        saveAnswers(store, answer) {
            Page.dispatch('addLoader', 'tests.saveAnswers')

            let params = {
                Id: answer.testId,
                TicketId: answer.ticketId,
            }

            for (let j in answer.answers) {
                saveAnswer(answer.answers[j].questionId, answer.answers[j].options)
                Questions.update({data: {id: answer.answers[j].questionId, answer: answer.answers[j].options}})
            }


            return api.post(`/api/v1/activities/Update`, answer, {params})
            .then(res => {
                //store.dispatch('insertOrUpdate', { data: res.data.data })
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'tests.saveAnswers')
            })
        },

        create(store, ticketId) {
            Page.dispatch('addLoader', 'tests.create')

            return api.post(`/api/v1/activities/Start?TicketId=${ticketId}`)
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data }).then((entities)=>{
                    createTest(res.data.data)
                })

                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'tests.create')
            })
        },
        fetchById(store, testId) {
            Page.dispatch('addLoader', 'tests.fetchById')

            return api.get(`/api/v1/activities/${testId}`)
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'tests.fetchById')
            })
        },
        fetchItems (store, params={}) {
            Page.dispatch('addLoader', 'tests.fetchItems')

            return api.get('/api/v1/activities', {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'tests.fetchItems')
            })
        },
        fetchActive(store, params={}){
            return store.dispatch('fetchItems', {IsActive: true})
        },
        fetchFinished(store, params={}){
            return store.dispatch('fetchItems', params)
        }

    }
}
